/**
 * LogoMark — spójny komponent loga CoreLTB Builders dla loaderów, splashscreenów
 * i miejsc gdzie chcemy markę. Auto-przełącza wariant (black/white) per motyw.
 *
 * Rozmiary:
 * - sm (h-8 / 32 px)  — inline loadery, RouteLoader, mini splash
 * - md (h-20 / 80 px) — duza wersja w SplashScreen welcome/logout
 * - lg (h-32 / 128 px) — emergency screens, np. fatal error
 *
 * Cel: jeden wzorzec wszedzie, eliminuje "skok rozmiaru" miedzy RouteLoader
 * a SplashScreen. Image preloadowany w index.html → zero opoznienia.
 */

type LogoSize = 'sm' | 'md' | 'lg';

const HEIGHT_CLASSES: Record<LogoSize, string> = {
  sm: 'h-8 sm:h-9',
  md: 'h-16 sm:h-20',
  lg: 'h-24 sm:h-32',
};

export function LogoMark({ size = 'md', className = '' }: { size?: LogoSize; className?: string }) {
  const h = HEIGHT_CLASSES[size];
  return (
    <>
      {/* Light mode → czarne logo */}
      <img
        src="/images/logo-black.webp"
        alt="CoreLTB Builders"
        decoding="async"
        className={`${h} w-auto object-contain dark:hidden ${className}`}
      />
      {/* Dark mode → biale logo */}
      <img
        src="/images/logo-white.webp"
        alt=""
        decoding="async"
        aria-hidden="true"
        className={`${h} w-auto object-contain hidden dark:block ${className}`}
      />
    </>
  );
}
